export default "__VITE_ASSET__CNL2sr4Q__"